<div class="spinner-container">
  <mat-spinner
    [strokeWidth]="spinnerOptions.strokeWidth"
    [diameter]="spinnerOptions.diameter"
  ></mat-spinner>
</div>
